import classNames from 'classnames';
import React, { ReactElement, MouseEvent } from 'react';

import { IParentProps } from '../../shared/types/IParentProps';

type INumberedPaginationButtonProps = IParentProps & {
    prominent?: boolean;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

export function NumberedPaginationButton (props: INumberedPaginationButtonProps): ReactElement {
    const { children, prominent = false, onClick }: INumberedPaginationButtonProps = props;

    const className: string = classNames({
        'font-gellix text-sm md:text-base text-gray-900': true,
        'font-normal': !prominent,
        'font-bold': prominent,
    });

    function handleClick (event: MouseEvent<HTMLButtonElement>): void {
        if (onClick) {
            onClick(event);
        }
    }

    return (
        <button className={className} onClick={handleClick}>
            {children}
        </button>
    );
}
